import { API_ENDPOINTS } from '@tsgecart/config';
import { storefrontApiFetch } from '../../../../lib/api/storefront-client.js';
import type { WishlistItem, MoveToCartInput } from '../types/wishlist.js';

export interface FetchOptions {
  token: string;
  signal?: AbortSignal;
}

export async function fetchWishlist(options: FetchOptions): Promise<WishlistItem[]> {
  return storefrontApiFetch<WishlistItem[]>(API_ENDPOINTS.wishlist, options);
}

export async function addWishlistItem(productId: string, options: FetchOptions): Promise<WishlistItem[]> {
  return storefrontApiFetch<WishlistItem[]>(`${API_ENDPOINTS.wishlist}/items`, {
    ...options,
    method: 'POST',
    body: { productId },
  });
}

export async function removeWishlistItem(itemId: string, options: FetchOptions): Promise<WishlistItem[]> {
  return storefrontApiFetch<WishlistItem[]>(`${API_ENDPOINTS.wishlist}/items/${itemId}`, {
    ...options,
    method: 'DELETE',
  });
}

export async function moveWishlistItemToCart(
  itemId: string,
  input: MoveToCartInput,
  options: FetchOptions,
): Promise<{ moved: boolean }> {
  return storefrontApiFetch<{ moved: boolean }>(`${API_ENDPOINTS.wishlist}/items/${itemId}/move-to-cart`, {
    ...options,
    method: 'POST',
    body: input,
  });
}
